import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import './style.datepicker.css'

class MokaDatePicker extends React.Component {
  render () {
    let {input, meta: {touched, error}, className, minDate} = this.props
    return (
      <div>
        <DatePicker {...input}
          dateFormat='DD/MM/YYYY'
          onBlur={() => input.onBlur()}
          selected={input.value ? moment(input.value) : null}
          placeholder='Payment Date'
          className={className}
          maxDate={moment()}
          minDate={minDate}
          readOnly
        />
        {touched && error && <span>{error}</span>}
      </div>
    )
  }
}

export default MokaDatePicker



// WEBPACK FOOTER //
// ./app/components/receipt/invoices/RecordPaymentModal/MokaDatePicker.js